module.exports = __webpack_public_path__ + "img/circle4green.4d41a191.png";